import {
  CLEAR_BACKLOGS,
  CLEAR_BACKLOGS_SERVICE_APPLETS,
  SET_BACKLOGS_FILTERS,
  SET_BACKLOGS_FULLSCREEN_IMAGE,
  SET_BACKLOGS,
  SET_BACKLOGS_SERVICE_APPLETS,
  SET_BACKLOGS_SNOWFLAKE,
  SET_BACKLOGS_POSTGRES,
  SET_BACKLOGS_POSTGRES_PINNED_EVENTS,
  SET_BACKLOGS_SNOWFLAKE_PINNED_EVENTS,
  SET_BACKLOGS_SNOWFLAKE_EVENTS,
  SET_BACKLOGS_POSTGRES_EVENTS,
  SET_BACKLOGS_POSTGRES_VALIDATED_EVENTS,
} from '../actions/backlogs';
import moment, { Moment } from 'moment';
import { FETCH_STATUS } from 'src/constants';
// import { sessionEventsListData } from 'src/__generated__/graphql';
import { REHYDRATE } from 'redux-persist';
import { Nullable } from 'src/types';
import { SortableSessionsDataProps } from 'src/views/Backlogs/VSnowflake/SortableSessions/SortableSessions';
import { SosImageProps } from 'src/views/Backlogs/VSnowflake/SortableSessions/Sos/Sos';

export type TBacklogsSyncSnowflakeEventsSessionsValidations = Array<{
  non_session_id: string;
  event_code: string;
  original_event_code: string;
  status: 'for_hmi' | 'complete';
  original_session_id: string;
  session_id: string;
  date_validated: string;
}>;

export type TBacklogsSyncSnowflakeEventsSessions = Array<{
  session_id: string;
  status: 'for_hmi' | 'complete';
  validations: TBacklogsSyncSnowflakeEventsSessionsValidations;
}>;

export enum BACKLOGS_SYNC_STATUS {
  FOR_HMI = 'for_hmi',
  COMPLETE = 'complete',
  PUBLISHED = 'published',
  FOR_HMI_REVIEW = 'for_hmi_review',
  FOR_HMI_REWORK = 'for_hmi_rework',
  DELETED = 'deleted',
}

export type TBacklogsSyncSnowflakeEventsPayload = {
  sessions: Array<{
    session_id: Nullable<string>; //set to null
    app_code: string;
    start_timestamp: string;
    end_timestamp: string;
    compliance_list: Array<any>;
    site_tz: string; //need pa mahibaw.an asa kuhaon
    network_id: number;
    network_name: string;
    site_name: string;
    site_id: number;
    doc_id: string; //sender ang mag send - UUID
    critical_events: Array<any>;
    calc_status: BACKLOGS_SYNC_STATUS;
    status: BACKLOGS_SYNC_STATUS;
    validations: Array<{
      non_session_id: Nullable<string>; //set to null, if ang session_id sa taas kay dli null copy session_id, if null kay generate dayun copy sa session
      event_code: string;
      event_location_id: number; //need pa mahibaw.an asa kuhaon
      event_location_name: string; //need pa mahibaw.an asa kuhaon
      event_site_tz: string; //need pa mahibaw.an asa kuhaon
      event_site_timestamp_utc: string; //queue in
      event_network_id: number;
      event_network_name: string;
      event_asset: string; //need pa mahibaw.an asa kuhaon
      event_timestamp: string; //queue in
      event_start_timestamp: string; //queue in
      event_end_timestamp: string; //queue out
      original_event_code: string;
      original_session_id: string;
      session_id: string;
      calc_non_session_id: Nullable<string>;
      status: BACKLOGS_SYNC_STATUS;
      date_validated: string;
    }>;
  }>;
};

export type TBacklogsServiceApplets = {
  data: TBacklogsServiceAppletsData[];
  isLoading: boolean;
  error: Nullable<string>;
};

export type TBacklogsServiceAppletsData = {
  code: Nullable<string>;
  name: Nullable<string>;
  app_logo: Nullable<string>;
};

export type TBacklogsFilters = {
  search: string;
  apps: Array<string>;
  sites: Array<number>;
  status: Array<string>;
  startTime: Moment;
  endTime: Moment;
  timezone: string;
  eventsPerPage: number;
  currentPage: number;
  offset: number;
  limit: number;
};

export type TBacklogsSnowflakeEvents = {
  data: Nullable<Array<SortableSessionsDataProps>>;
  fetchStatus: FETCH_STATUS;
  error: Nullable<string>;
};

export type TBacklogsPostgresEvents = {
  data: Nullable<Array<SortableSessionsDataProps>>;
  fetchStatus: FETCH_STATUS;
  error: Nullable<string>;
};

export type TBacklogsSnowflake = {
  refetchTrigger: number;
  isDraggingImage: boolean;
  draggingImageId: string;
  showBanner: boolean;
  errorEvent: Array<any>;
  events: TBacklogsSnowflakeEvents;
  pinnedEvents: TBacklogsPinnedEvents;
};

export type TBacklogsPinnedEvents = Array<SortableSessionsDataProps>;

export type TBacklogsPostgres = {
  pinnedEvents: TBacklogsPinnedEvents;
  events: TBacklogsPostgresEvents;
  refetchTrigger: number;
  isDraggingImage: boolean;
  draggingImageId: string;
  isPublishing: boolean;
};

export type TBacklogsValidated = {
  events: TBacklogsPostgresEvents;
};

export type TBacklogs = {
  results: number;
  pageCount: number;
  serviceApplets: TBacklogsServiceApplets;
  filters: TBacklogsFilters;
  postgres: TBacklogsPostgres;
  validated: TBacklogsValidated;
  snowflake: TBacklogsSnowflake;
  fullscreenImage: Nullable<SosImageProps>;
};

export const initialState: TBacklogs = {
  serviceApplets: {
    data: [],
    isLoading: false,
    error: null,
  },
  results: 0,
  pageCount: 1,
  postgres: {
    pinnedEvents: [],
    events: {
      data: null,
      fetchStatus: FETCH_STATUS.INTITIAL,
      error: null,
    },
    refetchTrigger: 0,
    isDraggingImage: false,
    draggingImageId: '',
    isPublishing: false,
  },
  validated: {
    events: {
      data: null,
      fetchStatus: FETCH_STATUS.INTITIAL,
      error: null,
    },
  },
  fullscreenImage: null,
  filters: {
    search: '',
    apps: [],
    startTime: moment().startOf('day'),
    endTime: moment().endOf('day'),
    timezone: '',
    sites: [],
    status: [],
    eventsPerPage: 100,
    currentPage: 0,
    offset: 0,
    limit: 0,
  },
  snowflake: {
    pinnedEvents: [],
    refetchTrigger: 0,
    isDraggingImage: false,
    draggingImageId: '',
    showBanner: false,
    errorEvent: [],
    events: {
      data: null,
      fetchStatus: FETCH_STATUS.INTITIAL,
      error: null,
    },
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REHYDRATE: {
      const incoming = action.payload?.backlogs || {};
      return {
        ...initialState,
        ...incoming,
      } as TBacklogs;
    }
    case SET_BACKLOGS: {
      return { ...state, ...action.data } as TBacklogs;
    }
    case SET_BACKLOGS_SERVICE_APPLETS: {
      return { ...state, serviceApplets: { ...state.serviceApplets, ...action.data } as TBacklogsServiceApplets };
    }
    case SET_BACKLOGS_FILTERS: {
      return { ...state, filters: { ...state.filters, ...action.data } as TBacklogsFilters };
    }
    case SET_BACKLOGS_POSTGRES: {
      return { ...state, postgres: { ...state.postgres, ...action.data } as TBacklogsPostgres };
    }
    case SET_BACKLOGS_SNOWFLAKE: {
      return { ...state, snowflake: { ...state.snowflake, ...action.data } as TBacklogsSnowflake };
    }
    case SET_BACKLOGS_SNOWFLAKE_PINNED_EVENTS: {
      return { ...state, snowflake: { ...state.snowflake, pinnedEvents: action.data as TBacklogsPinnedEvents } };
    }
    case SET_BACKLOGS_POSTGRES_PINNED_EVENTS: {
      return { ...state, postgres: { ...state.postgres, pinnedEvents: action.data as TBacklogsPinnedEvents } };
    }
    case SET_BACKLOGS_SNOWFLAKE_EVENTS: {
      return {
        ...state,
        snowflake: {
          ...state.snowflake,
          events: {
            ...state.snowflake.events,
            ...action.data,
          } as TBacklogsSnowflakeEvents,
        },
      };
    }
    case SET_BACKLOGS_POSTGRES_EVENTS: {
      return {
        ...state,
        postgres: {
          ...state.postgres,
          events: { ...state.postgres.events, ...action.data },
        },
      };
    }
    case SET_BACKLOGS_POSTGRES_VALIDATED_EVENTS: {
      return {
        ...state,
        validated: {
          ...state.validated,
          events: { ...state.validated.events, ...action.data } as TBacklogsPostgresEvents,
        },
      };
    }
    case SET_BACKLOGS_FULLSCREEN_IMAGE: {
      if (action.data) {
        return {
          ...state,
          fullscreenImage: { ...state.fullscreenImage, ...action.data } as Nullable<SosImageProps>,
        };
      }
      return {
        ...state,
        fullscreenImage: null,
      };
    }
    case CLEAR_BACKLOGS_SERVICE_APPLETS: {
      return {
        ...state,
        serviceApplets: {
          data: [],
          isLoading: false,
          error: null,
        },
      };
    }
    case CLEAR_BACKLOGS: {
      return initialState;
    }
    case CLEAR_BACKLOGS_SERVICE_APPLETS: {
      return { ...state, serviceApplets: initialState.serviceApplets };
    }
    default:
      return state;
  }
};
